export default {
  header: {
    code: '代码仓库',
    help: '帮助文档',
    user: '个人中心',
    signOut: '退出登录',
    setting: '系统设置',
  },
  notice: {
    title: '通知中心',
    clear: '清空',
    setRead: '设为已读',
    empty: '空',
    emptyNotice: '暂无通知',
    viewAll: '查看全部',
  },
  searchPlaceholder: '请输入搜索内容',
  tagTabs: {
    closeOther: '关闭其他',
    closeLeft: '关闭左侧',
    closeRight: '关闭右侧',
    refresh: '刷新',
  },
  setting: {
    title: '页面配置',
    theme: {
      mode: '主题模式',
      color: '主题色',
      options: {
        light: '明亮',
        dark: '暗黑',
        auto: '跟随系统',
      },
    },
    navigationLayout: '导航布局',
    sideMode: '侧边栏模式',
    splitMenu: '分割菜单（混合模式下有效）',
    fixedSidebar: '固定侧边栏',
    element: {
      title: '元素开关',
      showHeader: '显示顶栏',
      showBreadcrumb: '显示面包屑',
      showFooter: '显示页脚',
      useTagTabs: '展示多标签Tab页',
      menuAutoCollapsed: '菜单自动折叠',
    },
    tips: '请复制后手动修改配置文件: /src/config/style.ts',
    copy: {
      title: '复制配置项',
      success: '复制成功',
      fail: '复制失败',
    },
  },
};
